import { categoryClassMap } from '../config/categoryTags.js';

// Kategorie-Helper
export function getCategoryTag(tariff) {
  const { category, segment, isComboDiscounted } = tariff;
  
  if (isComboDiscounted || segment === "myhome") return null;
  if (!category || category === "Ohne Rabatt") return null;

  const className = categoryClassMap[category];
  return className ? { className, label: category } : null;
}

// Preis-Berechnungen
export function calculatePricing(tariff) {
  const { price, promoPrice, kombiOriginalPrice, isComboDiscounted, segment, promoLabel } = tariff;
  
  const safePrice = Number(price) || 0;
  const safePromoPrice = Number(promoPrice) || 0;
  const safeKombiPrice = isComboDiscounted ? (Number(kombiOriginalPrice) || 0) : 0;
  
  const promoLabelStr = promoLabel ? String(promoLabel) : "";
  const isMyHome = segment === "myhome";
  const hasMyHomePromo =
    isMyHome && (
      promoLabelStr.toLowerCase().includes("erste 12 monate") ||
      (safePromoPrice > 0 && safePrice > 0 && safePromoPrice < safePrice)
    );

  const displayPrice = isComboDiscounted 
    ? safePrice
    : (safePromoPrice > 0 && safePromoPrice < safePrice)
      ? safePromoPrice
      : safePrice;

  const regularPrice = isComboDiscounted
    ? safeKombiPrice
    : (safePromoPrice > 0 && safePromoPrice < safePrice)
        ? safePrice
        : (safePromoPrice > safePrice ? safePromoPrice : safePrice);

  const hasDiscount = isComboDiscounted || (safePromoPrice > 0 && safePromoPrice < safePrice);
  
  const savingsTotal = hasDiscount && regularPrice > 0
    ? regularPrice - displayPrice
    : 0;
    
  const hasSavings = savingsTotal > 0.01;
  const savingsPercent = hasSavings && regularPrice > 0
    ? Math.round((savingsTotal / regularPrice) * 100)
    : 0;

  return {
    displayPrice,
    regularPrice,
    hasDiscount,
    hasPromo: hasDiscount,
    hasMyHomePromo,
    savingsTotal,
    hasSavings,
    savingsPercent,
    savingsMonthly: savingsTotal,
    savingsYear: savingsTotal * 12,
    savingsTwoYears: savingsTotal * (tariff.segment === "prepaid" ? 1 : 24),
    savingsDaily: savingsTotal / 30
  };
}
